import React, {Component} from 'react';
import OpenOrderBook from './OpenOrders/index.jsx';
import MatchedOrders from './MatchedOrders/index.jsx';

class Bottom extends Component {
  render() {
    return (
      <div className='row' style={{marginBottom:'20px'}}>
        <OpenOrderBook view={'open'}/>
        <MatchedOrders view={'complete'}/>
        <OpenOrderBook view={'closed'}/>
        <MatchedOrders view={'historical'}/>
      </div>
    )
  }
}

export default Bottom;
